<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'UploadData',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=6',
      shareHaderName: '支付订单',
      pageConfig: {
        sections: [
          {
            steps: [
              {
                title: '支付（店员操作）',
                hideCount: true,
                description: [
                  '店员对信息进行核对，点击「立即支付」完成支付，如余额不足应在充值后对订单进行支付',
                ],
                sub: [
                  {
                    title: '使用微信小程序支付',
                    images: [{ name: '6_01' }],
                  },
                  {
                    title: '店员使用官网支付',
                    images: [{ name: '6_02' }],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '支付订单',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/PayOrder.vue